import { setRecoil } from 'recoil-nexus';
import InterphoneController, { CALL_TYPE_RECEIVER } from '../controller/InterphoneController';
import {
  INTERPHONE_STATUS_CALLING,
  INTERPHONE_STATUS_CANCEL,
  INTERPHONE_STATUS_RECEIVER_WAIT,
} from '../recoil/area';
import {
  fcmConciergeCountState,
  fcmConciergeState,
  fcmInterphoneState,
  fcmSalesCountState,
  fcmSalesState,
  MESSAGE_TYPE_CONCIERGE,
  MESSAGE_TYPE_INTERPHONE,
  MESSAGE_TYPE_SALES,
} from '../recoil/fcmMessage';

export const handleFirebaseMsg = async (receivedData: any, countTemp: number) => {
  if (receivedData.data.type === MESSAGE_TYPE_SALES) {
    setRecoil(fcmSalesState, new Date().getTime().toString());
    if (
      receivedData.data.update_order_status === '0' ||
      (receivedData.data.confirmed_by === '1' && receivedData.data.update_order_status === '1')
    ) {
      countTemp += 1;
      setRecoil(fcmSalesCountState, countTemp);
    }
    console.log('[SALES] Background Message received.\n', '\n', receivedData, countTemp);
  } else if (receivedData.data.type === MESSAGE_TYPE_CONCIERGE) {
    countTemp += 1;
    setRecoil(fcmConciergeState, {
      date: new Date().getTime().toString(),
      clientUserId: Number(receivedData.data.clientUserId),
    });
    setRecoil(fcmConciergeCountState, countTemp);

    console.log('[CONCIERGE] Background Message received.\n', '\n', receivedData, countTemp);
  } else if (receivedData.data.type === MESSAGE_TYPE_INTERPHONE) {
    // 통화 발신
    if (receivedData.data.typeDetail === 'REQUEST_INCOME') {
      setRecoil(fcmInterphoneState, (prev) => ({
        ...prev,
        type: CALL_TYPE_RECEIVER,
        interphone_call_manage_id: Number(receivedData.data.interphone_call_manage_id),
        status: INTERPHONE_STATUS_RECEIVER_WAIT,
      }));
      await InterphoneController.setReqCallDataReceived({
        manage_id: Number(receivedData.data.interphone_call_manage_id),
      });
    }
    // 상대방의 통화 수락
    else if (receivedData.data.typeDetail === 'RECEIVER_ACCEPT') {
      setRecoil(fcmInterphoneState, (prev) => ({
        ...prev,
        interphone_call_manage_id: Number(receivedData.data.interphone_call_manage_id),
        status: INTERPHONE_STATUS_CALLING,
      }));
    }
    // 방 생성
    else if (receivedData.data.typeDetail === 'CREATED_ROOM') {
      setRecoil(fcmInterphoneState, (prev) => ({
        ...prev,
        interphone_call_manage_id: Number(receivedData.data.interphone_call_manage_id),
        // room_name: Number(receivedData.data.room_name),
        // status: INTERPHONE_STATUS_CALLING,
      }));
    }
    // 상대방의 통화 거절
    else if (receivedData.data.typeDetail === 'REQUEST_CANCEL_BY_RECEIVER') {
      setRecoil(fcmInterphoneState, (prev) => ({
        ...prev,
        interphone_call_manage_id: Number(receivedData.data.interphone_call_manage_id),
        room_name: null,
        status: INTERPHONE_STATUS_CANCEL,
        reject_reason: '수신자가 통화를 거절했습니다',
      }));
    }
    // 발신자의 통화 거절
    else if (receivedData.data.typeDetail === 'REQUEST_CANCEL_BY_SENDER') {
      setRecoil(fcmInterphoneState, (prev) => ({
        ...prev,
        interphone_call_manage_id: Number(receivedData.data.interphone_call_manage_id),
        room_name: null,
        status: INTERPHONE_STATUS_CANCEL,
        reject_reason: '발신자가 통화를 거절했습니다',
      }));
    } else if (receivedData.data.typeDetail === 'REQUEST_CANCEL_BY_TIMEOUT') {
      setRecoil(fcmInterphoneState, (prev) => ({
        ...prev,
        interphone_call_manage_id: Number(receivedData.data.interphone_call_manage_id),
        room_name: null,
        status: INTERPHONE_STATUS_CANCEL,
        reject_reason: '지금은 전화를 연결할 수 없습니다',
      }));
    }

    console.log('[INTERPHONE] Background Message received.\n', '\n', receivedData);
  }
};
